import api from '../../common/libs/api.js';
import async from 'async';
const home = {
  state: {
    city: {  //保存定位和选择的城市
      city_code: '010',
      city_name: '北京',
      lat: '',   //经度
      lng: '',  //纬度
      open_city: true,
      first_word: 'bj'
    },
    location: {  //保存定位的数据，不是选择的,
      isGet: 2  //1代表定位成功，2代表定位失败，3代表定位中
    },
    citys: {
      openCitys: [],   //保存校区城市信息
      allCitys: []    //保存所有城市信息
    },
    commons: {  //常用的一些
      city_arr: {},
      leyu: [],
      qr_code: {}
    },
    isScroll: false,
    logo: {
      img_url: ''
    },  //头部logo信息
    sysCourseList: [],   //保存首页课程体系的信息
    recommendCourseList: [],     //保存首页推荐课程信息
    network: true,    //保存网络状态的，true为有网，false为断网
    homeBanner: [],    //保存首页的banner
    isShowLoading: false,  //是否显示全局loading
    isLocationChanged: 1  //是否已经切换过城市了
  },
  mutations: {
    refreshFooter(home, refreshFooter) {
      home.refreshFooter = refreshFooter;
    },
    setIsLocationChanged(home, isLocationChanged) {
      home.isLocationChanged = isLocationChanged;
    },
    isShowLoading(home, isShowLoading) {
      home.isShowLoading = isShowLoading;
    },
    changeNetWork(home, network) {
      home.network = network;
    },
    addLogo(home, logo) {
      home.logo = logo;
    },
    isScroll(home, isScroll) {
      home.isScroll = isScroll;
    },
    addLocation (home, location) {
      home.location = location;
    },
    addCommons (home, commons) {
      home.commons = commons;
    },
    changeIsGet (home, isGet) {
      home.location.isGet = isGet;
    },
    setCity (home, payload) {
      home.city = payload;
    },
    addHomeBanner (home, payload) {
      home.homeBanner = payload;
    },
    /**
       * 初始化首页数据，包括
       * banners,
       * sysCourseList,
       * recommendCourseList
       * */
    initHomeData (home, preload) {
      home.homeBanner = preload.banners;
      home.sysCourseList = preload.sysCourseList;
      home.recommendCourseList = preload.recommendCourseList;
    },
    /**
		 * 初始化城市信息，包括
		 * allCitys 所有城市列表
		 * openCitys 智康线下城市列表
		 * */
    initCitiesData (home, preload) {
      home.citys.openCitys = preload.openCities;
      // home.citys.allCitys = preload.allCities;
    }
  },
  actions: {
    initCitiesData (context, params) {
      return new Promise((resolve, reject) => {
        async.parallel({
          // allCities: (done) => {
          //   api.apiMethod.getAllCitys.get(params).then(res => {
          //     if (res.data.errid === 0) {
          //       done(null, res.data.content.list);
          //     } else {
          //       done(null, []);
          //     }
          //   });
          // },
          openCities: (done) => {
            api.apiMethod.getOpenCitys.get(params).then(res => {
              if (res.data.errid === 0) {
                done(null, res.data.content.list);
              } else {
                done(null, []);
              }
            });
          }
        }, (err, resp) => {
          if (err) {
            reject(err);
          } else {
            resolve(resp);
          }
        });
      }).then(resp => {
        context.commit('initCitiesData', resp);
      });
    },
    initHomeData(context, params) {
      return new Promise((resolve, reject) => {
        async.parallel({
          banners: (done) => {
            api.apiMethod.banner.get(params).then(res => {
              if (res.data.errid === 0) {
                done(null, res.data.content.list||[]);
              } else {
                done(null, []);
              }
            });
          },
          recommendCourseList: (done) => {
            api.apiMethod.getCourseRecommend.post({city: params.city_code}).then(res => {
              if (res.data.errid === 0) {
                done(null, res.data.content||[]);
              } else {
                done(null, []);
              }
            });
          },
          sysCourseList: (done) => {
            api.apiMethod.getLoginIcon.post({type: 'systemBtn'}).then(res => {
              if (res.data.errid == 0) {
                done(null, res.data.content.list||[]);
              } else {
                done(null, []);
              }
            });
          }
        }, (err, res) => {
          if (err) {
            reject(err);
          } else {
            resolve(res);
          }
        });
      }).then(resp => {
        context.commit('initHomeData', resp);
      });
    },
    getHomeBanner(context, payload) {
      return api.apiMethod.banner.get(payload).then(res => {
        if (res.data.errid == 0) {
          context.commit('addHomeBanner', res.data.content.list);
        } else {
          context.dispatch('toast', {title: res.data.errmsg, show: true});
        }
      });
    },
    getLogo(context, payload) {
      return api.apiMethod.logo.get(payload).then(res => {
        if (res.data.errid == 0) {
          context.commit('addLogo', res.data.content.list[0]);
        } else {
          context.dispatch('toast', {title: res.data.errmsg, show: true});
        }
      })
    },
    getCity (context, payload) {
      return api.apiMethod.getCity.post(payload).then(res => {
        if (res.data.errid == 0) {
          context.commit('addLocation', {
            isGet: 1,
            city_code: res.data.content.city_code,
            city_name: res.data.content.city_name,
            lat: res.data.content.lat,
            lng: res.data.content.lng,
            open_city: res.data.content.open_city,
            first_word: res.data.content.first_word
          });
          //context.commit('setCity', res.data.content);
        } else {
          context.dispatch('toast', {show: true, title: res.data.errmsg});
          context.commit('changeIsGet', 2);
        }
      }).catch(err => {
        context.commit('changeIsGet', 2);
      })
    },
    //获取乐语链接
    fetchCommons(context, payload) {
      return api.apiMethod.commonLinks.get().then(res => {
        if (res.data.errid == 0) {
          context.commit('addCommons', res.data.content);
        } else {
          context.dispatch('toast', {title: res.data.errmsg, show: true});
        }
      })
    }
  }
};

export default home;



// WEBPACK FOOTER //
// ./src/stores/modules/home.js